export default __webpack_public_path__ + "static/media/headerImgDeco1.492620c7.png";